import React from "react";
import { Tasks } from "../components/Tasks/Tasks";
import { Page } from "../components/Page/Page";
import "./PageLayout.css";

export function TasksPage() {
  return (
    <Page>
      <div className="page-layout page-layout--animated">
        <div className="page-content">
          <Tasks />
        </div>
      </div>
    </Page>
  );
}
